var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-info-item d-flex"},[_c('div',{staticClass:"name m-t-3"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"w-100"},[_vm._t("values")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }